import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

const ACCENT = {
  amber: "bg-amber-500/10 border-amber-500/20 text-amber-600",
  sky: "bg-sky-500/10 border-sky-500/20 text-sky-600",
  emerald: "bg-emerald-500/10 border-emerald-500/20 text-emerald-600",
} as const;

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  icon: LucideIcon;
  accent?: keyof typeof ACCENT;
  children: ReactNode;
  footer: ReactNode;
};

export function PartyUpsertDialog({
  open,
  onOpenChange,
  title,
  description,
  icon: Icon,
  accent = "amber",
  children,
  footer,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] overflow-y-auto p-6">
        <DialogHeader className="pb-3 border-b border-border/50">
          <div className="flex items-center gap-2">
            <div
              className={cn(
                "h-9 w-9 rounded-xl border flex items-center justify-center",
                ACCENT[accent],
              )}
            >
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <DialogTitle className="text-lg font-bold text-foreground">{title}</DialogTitle>
              <p className="text-xs text-muted-foreground">{description}</p>
            </div>
          </div>
        </DialogHeader>
        <div className="space-y-4 py-2">{children}</div>
        <DialogFooter className="pt-4 border-t border-border/50 gap-2">{footer}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
